import { Checkbox, Field, NumericInput, TextOutput } from 'Components/Core';
import { WorksheetGridFieldSection, WorksheetRecordGrid } from 'Components/Worksheets/Core';
import { prefixRecordFieldSetNames } from 'Components/Worksheets/Core/WorksheetRecordGrid/helpers';
import { createDryMassEntryOptionSelector } from 'Components/Worksheets/MoistureContentWorksheet';
import { getGridFieldSet as getMoistureContentGridFieldSet } from 'Components/Worksheets/MoistureContentWorksheet/Aashto/gridFieldSets';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import deepEquals from '../../../../../../Lib/Object/deepEquals';
import { withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { LiquidLimitSpecimen } from '../../types';
import { ILiquidLimitFourPointSection } from './LiquidLimitFourPointDeterminationSection';

let AsLiquidLimitFourPointTrialSection: React.FC<ILiquidLimitFourPointSection> = ({
  createWorksheetSelector,
  hideLinearShrinkageFields = true,
}) => {
  const dryMassEntryOption = useSelector(createDryMassEntryOptionSelector(createWorksheetSelector!));
  const trialRecordProps = useSelector(
    pipe(createWorksheetSelector!('Trials'), valueOrDefault([] as Array<LiquidLimitSpecimen>), (trials) =>
      trials.map((t, i) => ({
        dim: t.ExcludedTrial,
        preventRemove: i < 4,
        SuitableForShrinkage: t.SuitableForShrinkage,
      }))
    ),
    deepEquals
  );

  return (
    <WorksheetGridFieldSection name="Trials">
      <WorksheetRecordGrid
        name={'Trials'}
        orientation={'horizontal'}
        recordProps={{
          heading: 'number',
          width: 130,
          preventRemove: (i) => trialRecordProps[i]?.preventRemove,
          dim: (i) => trialRecordProps[i]?.dim,
          enforceAtLeastOneRecord: true,
          removeConfirm: {
            confirm: true,
            confirmTitle: 'Trial Deletion',
            confirmText: 'Are you sure you want to delete the selected trial?',
            confirmButtonText: 'Delete Trial',
          },
        }}
        fieldSet={[
          {
            name: 'Drops',
            component: <Field input={<NumericInput />} />,
          },
          {
            name: 'Drops2',
            component: <Field input={<NumericInput />} />,
          },
          {
            name: 'NumberOfDrops',
            component: <Field input={<TextOutput />} />,
          },
          ...prefixRecordFieldSetNames('MoistureDetermination', getMoistureContentGridFieldSet(dryMassEntryOption)),

          {
            name: 'SuitableForShrinkage',
            component: (i) =>
              trialRecordProps[i].SuitableForShrinkage ? (
                <Field input={<TextOutput />} value={'Yes'} severity="success" />
              ) : (
                <Field input={<TextOutput />} value={'No'} />
              ),
            hidden: hideLinearShrinkageFields,
          },
          {
            name: 'ExcludedTrial',
            component: <Field input={<Checkbox />} />,
          },
        ]}
      />
    </WorksheetGridFieldSection>
  );
};

AsLiquidLimitFourPointTrialSection = withInjectedProps(AsLiquidLimitFourPointTrialSection);

export { AsLiquidLimitFourPointTrialSection };
export default AsLiquidLimitFourPointTrialSection;
